/**
 * AirTimeDisplay Component
 *
 * Displays air time with color-coded reliability indicators.
 *
 * Features:
 * - Color coding based on reliability (Green/Yellow/Red)
 * - Reliability badge
 * - Confidence score percentage
 * - Warning icon for corrected values
 * - Error message for unreliable values
 * - Tooltip with correction details
 */

import React from 'react';
import './AirTimeDisplay.css';

const AirTimeDisplay = ({ metrics, showDetails = true }) => {
  if (!metrics || metrics.air_time === undefined) {
    return null;
  }

  const airTime = metrics.air_time;

  return (
    <div className="measurement-item">
      <span className="measurement-label">Air Time:</span>
      <span className="measurement-value">
        {airTime.toFixed(3)} s
      </span>
      <span className="measurement-subtext">
        (Elite: 0.65s)
      </span>
    </div>
  );
};

export default AirTimeDisplay;
